<template>
    <el-select
      v-model="value"
      placeholder="请选择"
      @change="change"
      :disabled="disableStatus"
      :multiple="!!data.selectType"
      class="input-form"
    >
      <el-option
        v-for="(item,index) of data.options"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
</template>

<script>
export default {
  // props: ["data", "modelDat", "disableStatus"],
  props: {
    data: {
      type: Object
    },
    modelDat: {
      type: [String, Boolean, Object, Array,Number ]
    },
    disableStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      value: this.value,
      flag: true
    };
  },

  methods: {
    change() {
    //  let changeData;
    //  if(Array.isArray(this.value)) changeData = this.value.join(",")
    //  else changeData = this.value
      this.$emit("inputChange", {
        key: this.data.field,
        value: this.value 
      });
    }
  },

  watch: {
    modelDat(newValue) {
      this.value = newValue;

    },
    data: {
      handler(value) {
        
      },
      deep: true
    }
  }
};
</script>